module.exports = __webpack_public_path__ + "img/ChatResearch_banner.891612cc.png";